export enum ActionType_Enum {
    None = 0,
    DocumentsNeeded = 1,
    NoteAdded = 2,
    VehicleChange = 3
  }
  